import { Pipe, PipeTransform } from '@angular/core';

type Sign = '+' | '-' | '';

@Pipe({
  name: 'signNumber',
})
export class SignNumberPipe implements PipeTransform {
  public transform(value: number | string): string {
    if (value) {
      const res = this._getUnsignedNumber(value);
      const sign = this._getNumberSign(value);
      return `${sign}${res}`;
    }
    return String(value);
  }

  private _getUnsignedNumber(value: number | string): string {
    return this._getTrimmedNumber(value).replace(/[+-]/g, '');
  }

  private _getNumberSign(value: number | string): Sign {
    const numValue = Number(this._getTrimmedNumber(value).replace(/\s/g, ''));
    if (!numValue) {
      return '';
    }
    return numValue > 0 ? '+' : '-';
  }

  private _getTrimmedNumber(value: number | string): string {
    return String(value).trim();
  }
}
